import {
  afterNextRender,
  Component,
  effect,
  ElementRef,
  Inject,
  inject,
  OnInit,
  QueryList,
  signal,
  TemplateRef,
  ViewChild,
  ViewChildren,
  WritableSignal,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { SearchResultUiService } from '../../../pages/search-result/services/search-result-ui.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MapService } from '@shared/services/map.service';
import { relativeTimeThreshold } from 'jalali-moment';
import { ActivatedRoute, Router } from '@angular/router';
import { MapHotelCardComponent } from './components/map-hotel-card/map-hotel-card.component';
import { MapHotelPopupComponent } from './components/map-hotel-popup/map-hotel-popup.component';
import { MapHotelSearchboxComponent } from './components/map-hotel-searchbox/map-hotel-searchbox.component';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { PLATFORM_ID } from '@angular/core';
import { WINDOW } from '@core/layouts/website/website.component';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
export declare var L: any;

@Component({
  selector: 'iho-map',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    MatSidenavModule,
    MapHotelCardComponent,
    MapHotelPopupComponent,
    RialToTomanPipe,
    MapHotelSearchboxComponent,
  ],
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: [RialToTomanPipe],
})
export class MapComponent implements OnInit {
  @ViewChild('neshanMap', { static: true }) neshanMap!: any;
  @ViewChild('mapHotelPopup', { static: true }) mapHotelPopup!: any;
  @ViewChildren('card') hotelCards!: QueryList<ElementRef>;
  mapService = inject(MapService);
  route = inject(ActivatedRoute);
  searchResultUiService = inject(SearchResultUiService);
  map: any;
  csrStatus = signal(false);
  infoPage: any;
  swiperConfigMobile!: SwiperOptions;
  @ViewChild('swiper', { static: false }) swiperMobile?: SwiperComponent;
  datasource: any = [];
  itemWithRoute: any;
  hotelMarkers!: Record<string, any>[];
  hotelsLocations = new Map<any, any>();
  selectedHotel: WritableSignal<[number, number]> = signal([0, 0]);
  activeHotel: WritableSignal<any> = signal({});
  showHotelListDrawer = true;
  RialToTomanPipe = inject(RialToTomanPipe);
  platformId = inject(PLATFORM_ID);
  swiperService = inject(SwiperService);

  navigatorVal: WritableSignal<boolean | undefined> = signal(undefined);
  point: any = undefined;
  ActiveRoute = inject(ActivatedRoute);
  constructor(@Inject(WINDOW) public window: Window) {
    afterNextRender(() => {
      if (isPlatformBrowser(this.platformId))
        this.window.scrollTo(0, 0);
    });
    if (isPlatformBrowser(this.platformId))
      this.navigatorVal.set(!/Android|iPhone|iPad/.test(this.window.navigator.userAgent));

    effect(() => {
      if (this.selectedHotel() && this.map) {
        this.map.setView(this.selectedHotel(), 16);
      }
    });

    effect(() => {
      this.datasource = this.searchResultUiService.searchResult().Cards;
      this.infoPage = this.searchResultUiService.searchResult().PageTitle;

      if (this.datasource && isPlatformBrowser(this.platformId) && this.navigatorVal() != undefined) {
        setTimeout(() => {
          this.map = new L.Map('map-content', {
            key: process.env['IHO_NESHAN_API_KEY'],
            maptype: 'neshan',
            poi: false,
            traffic: false,
            center: [this.datasource[0].CardData.Address.Lat, this.datasource[0].CardData.Address.Long],
            zoom: 14,
          });
        }, 0);
      }

      setTimeout(() => {
        if (this.map && isPlatformBrowser(this.platformId)) {
          this.hotelMarkers = this.renderHotelMarkers();
        }
      }, 0);
      setTimeout(() => {
        if (this.map && isPlatformBrowser(this.platformId)) {
          this.ActiveRoute.queryParams.subscribe(params => {
            if (params['houseId'] || params['hid']) {
             let houseId = params['houseId'] ? params['houseId'] : params['hid'];
              this.updateHotelList(houseId);
              this.itemWithRoute = this.datasource.find((item: any) => (item.CardData.Id != -1 ? item.CardData.Id : item.CardData.HouseId) == houseId);
              if(this.navigatorVal())
              this.syncHotellistWithMarker(this.itemWithRoute.CardData);
            }
          });
        }
      }, 1000);
    });
  }
  ngOnInit(): void {
   
    const config = {
      slide: 1,
      pagination: {
        enabled: false,
        clickable: true,
        isMobile: this.navigatorVal,
      },
    };

    this.swiperConfigMobile = this.swiperService.SwiperConfig(config);
    if (isPlatformBrowser(this.platformId)) {
      this.csrStatus.set(true);
    }
  }

  renderHotelMarkers() {
    const hotelMarkers = this.datasource.map((hotel: any) => {
      this.hotelsLocations.set(hotel.CardData.Address.Lat, hotel.CardData);
      const marker = new L.marker([hotel.CardData.Address.Lat, hotel.CardData.Address.Long], {
        icon: new L.Icon({
          iconUrl: 'assets/images/leaflet-marker-hotel.svg',
          iconSize: [82, 98],
          iconAnchor: [40, 5],
          riseOnHover: true,
        }),
      });
      const hotelPrice = Math.floor(this.RialToTomanPipe.transform(hotel?.CardData?.Price?.IhoPrice)).toLocaleString();
      const pricetooltipOffset: any = {
        '8': '110',
        '6': '75',
        '4': '85',
      };

      if (hotelPrice != '0') {
        marker
          .bindTooltip(hotelPrice + ' تومان', {
            permanent: true,
            direction: 'top',
            className: 'hotel-map-price-tooltip',
            offset: [100, 0],
          })
          .openTooltip(true);
      }

      if (this.navigatorVal()) {
        marker.bindPopup(this.mapHotelPopup.nativeElement, {
          minWidth: 300,
          closeButton: false,
          className: 'hotel-map-popup',
        });
      }
      marker.addTo(this.map);
      marker.on('click', this.handleMarkertClickEvent.bind(this));
      return marker;
    });
    return hotelMarkers;
  }

  handleMarkertClickEvent(marker: any) {
    let idSelectedHotel = this.hotelsLocations.get(marker.latlng.lat).Id != -1 ?
      this.hotelsLocations.get(marker.latlng.lat).Id :
      this.hotelsLocations.get(marker.latlng.lat).HouseId;
    this.selectedHotel.set([marker.latlng.lat, marker.latlng.lng]);
    this.activeHotel.set(this.hotelsLocations.get(marker.latlng.lat));
    this.showHotelListDrawer = true;
    this.updateHotelList(idSelectedHotel);
  }

  searchBoxSelectItem(hotelData: any) {
    this.selectedHotel.set([hotelData.Address.Lat, hotelData.Address.Long]);
    this.activeHotel.set(hotelData);
    this.showHotelListDrawer = true;
    this.updateHotelList(hotelData.Id != -1 ? hotelData.Id : hotelData.HouseId);
  }

  syncHotellistWithMarker(hotelData: any) {
    this.hotelCards.forEach((el: any) => {
      if (el.nativeElement.id === `card-${hotelData.Id != -1 ? hotelData.Id : hotelData.HouseId}`) {
        el.nativeElement.firstChild.firstChild.classList.add('border-blue-500');
        el.nativeElement.firstChild.firstChild.classList.add('border-2');
      } else {
        el.nativeElement.firstChild.firstChild.classList.remove('border-blue-500');
        el.nativeElement.firstChild.firstChild.classList.remove('border-2');
      }
    });
    const hotelMarker = this.hotelMarkers.find(
      (marker: any) => marker?.['_latlng'].lat === hotelData.Address.Lat
    );
    this.selectedHotel.set([hotelData.Address.Lat, hotelData.Address.Long]);
    this.activeHotel.set(hotelData);
    this.showHotelListDrawer = true;
    if (this.navigatorVal()) {
      (hotelMarker as any).openPopup();
    }
  }

  updateHotelList(id: string) {
    this.hotelCards.forEach((el: any) => {
      if (el.nativeElement.id === `card-${id}`) {
        el.nativeElement.firstChild.firstChild.classList.add('border-blue-500');
        el.nativeElement.firstChild.firstChild.classList.add('border-2');
        el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        el.nativeElement.firstChild.firstChild.classList.remove('border-blue-500');
        el.nativeElement.firstChild.firstChild.classList.remove('border-2');
      }
    });
  }
  backHistory(){
     this.window.history.back();
  }
}
